import { useEffect, useState } from "react"
import { MedicalCamp, MedicalCampDetails } from "../types/medicalCamp"
import { ChevronDown, ChevronUp, Delete, Eye, EyeOff, X } from "lucide-react"
import transparentBg from "../assets/images/transparent-bg.png";
import { SupervisorService } from "../services/api/supervisior.service";
import toast from "react-hot-toast";
import { DoctorService } from "../services/api/doctor.service";
import { MedicalCampService } from "../services/api/medicalCamp.Service";


interface AddNewMedicalCampMdoalProps {
    onClose: () => void
    onSuccess: () => void
    setInitialData: React.Dispatch<React.SetStateAction<MedicalCamp | null>>;
    initialData: MedicalCamp | null
}

export function AddNewMedicalCampModal({
    onClose,
    onSuccess,
    setInitialData,
    initialData,
}: AddNewMedicalCampMdoalProps) {
    const [medicalCampDetails, setMedicalCampDetails] = useState<MedicalCampDetails>({
        role:"MedicalCamp",
        username:"",
        password:"",
        campName: "",
        mobileNumber:"",
        campSupervisorName:"",
        campStartDate: "",
        campEndDate: "",
        campAddress: "",
        // campSupervisorId: "",
        city:"",
        pincode:"",
        state:"",
        campDoctors: [],
    })

    const [doctors, setDoctors] = useState<
        {
            userId: string;
            name: string;
            education: string;
            specialization: string;
            hospitalName: string;
            profileImage?: string
        }[]
    >([])
    
    // const [supervisiors, setSuperisors] = useState<
    //     { userId: string; name: string }[]
    // >([])
    const [showPassword, setShowPassword] = useState(false);
    const [isLoading,setIsLoading] = useState(true)

    useEffect(() => {
        if (initialData) {
            setMedicalCampDetails({
                role:initialData.role ,
                username:initialData.username || "",
                password:initialData.password || "",
                campName: initialData.campName || "",
                mobileNumber:initialData.mobileNumber || "",
                campSupervisorName:initialData.campSupervisorName || "",
                campStartDate: initialData.campStartDate || "",
                campEndDate: initialData.campEndDate || "",
                campAddress: initialData.campAddress || "",
                // campSupervisorId: initialData.campSupervisorId || "",
                city:initialData.city || "",
                pincode:initialData.pincode || "",
                state:initialData.state || "",
                campDoctors: initialData.campDoctors ? initialData.campDoctors.map(doctor => ({
                    doctorId: doctor.doctorId,
                    amount: doctor.amount || 0
                })) : []
            })
        } else {
            setInitialData(null)
        }
    }, [initialData])

    // Fetch Superviors to show on Modal Mount
    // useEffect(() => {
    //     const fetchSupervisors = async () => {
    //         try {
    //             const response = await SupervisorService.getSupervisors({
    //                 page: 1,
    //                 pageSize: 10,
    //             });

    //             if (response.success && response.data?.dataList) {
    //                 setSuperisors(response.data.dataList)
    //             } else {
    //                 toast.error(response.message || "No Superviors found")
    //             }
    //         } catch (error) {
    //             console.error("Error fetching supervisors:", error);
    //             toast.error("An error occurred while fetching supervisors");
    //         }
    //     }

    //     fetchSupervisors()
    // }, [])

    // Fetch doctors to show on Modal Mount
    useEffect(() => {
        const fetchDoctors = async (page = 1, pageSize = 1000) => {
            try {
                const response = await DoctorService.getDoctors({ page, pageSize })

                if (response.success && response.data.dataList) {
                    setDoctors(response.data.dataList.map((item: any) => item.doctorDetails))
                } else {
                    toast.error(response.message || "No Doctors found")
                }

            } catch (error) {
                console.error("Error fetching doctors:", error);
                toast.error("An error occurred while fetching doctors");
            }
        }
        fetchDoctors()
    }, [])



    function formatDateToBackendFormat(dateString: string): string {
        const [year, month, day] = dateString.split("-");
        return `${day}-${month}-${year}`;
    }
    
    const validateForm = (): string | true => {
        if (medicalCampDetails.campName.trim().length === 0) {
          return "Camp Name is required for registration";
        }
        if (medicalCampDetails.mobileNumber.trim().length === 0) {
          return "Mobile Number is required for registration";
        }
        // if (!medicalCampDetails.mobileNumber.match(/^\d{10}$/)) {
        //   return "Invalid Mobile Number";
        // }
        if (medicalCampDetails.campStartDate.length === 0) {
          return "Camp Start  Date is required for registration";
        }
        if (medicalCampDetails.campEndDate.length === 0) {
          return "Camp End Date is required for registration";
        }
        if(medicalCampDetails.campStartDate > medicalCampDetails.campEndDate){
            return "Camp Start & End Dates are Invalid"
        }
        if (medicalCampDetails.state.trim().length === 0) {
          return "State is required for registration";
        }
        if (medicalCampDetails.city.trim().length === 0) {
          return "City is required for registration";
        }
        if (medicalCampDetails.pincode.trim().length === 0) {
          return "Pincode is required for registration";
        }
        if (medicalCampDetails.pincode.length < 6) {
          return "Invalid Pincode";
        }
        if (medicalCampDetails.campSupervisorName.trim().length === 0) {
          return "Camp Supervisor Name is required for registration";
        }
        if(medicalCampDetails.campDoctors.length === 0){
           return "Please select any one of the doctors"
        }
        if (medicalCampDetails.campAddress.trim().length === 0) {
          return "Address is required for registration";
        }
        if (medicalCampDetails.username.trim().length === 0) {
          return "Username is required for registration";
        }
        if (medicalCampDetails.password.trim().length === 0) {
          return "Password is required for registration";
        }
        return true;
      };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault()
        
        const validationResult = validateForm()

        if(validationResult !== true){
            toast.error(validationResult)
            return
        }

        // Format dates to DD-MM-YYYY
        const formattedStartDate = formatDateToBackendFormat(medicalCampDetails.campStartDate);
        const formattedEndDate = formatDateToBackendFormat(medicalCampDetails.campEndDate);

        const payload = {
            id: initialData?.id || "", // ID for updates
            role:medicalCampDetails.role,
            username:medicalCampDetails.username,
            password:medicalCampDetails.password,
            campName: medicalCampDetails.campName,
            mobileNumber:medicalCampDetails.mobileNumber,
            campSupervisorName:medicalCampDetails.campSupervisorName,
            campStartDate: formattedStartDate,
            campEndDate: formattedEndDate,
            state:medicalCampDetails.state,
            city:medicalCampDetails.city,
            pincode:medicalCampDetails.pincode,
            campAddress: medicalCampDetails.campAddress,
            // campSupervisorId: medicalCampDetails.campSupervisorId,
            campDoctors: medicalCampDetails.campDoctors ? medicalCampDetails.campDoctors.map(doctor => ({
                doctorId: doctor.doctorId,
                amount: doctor.amount || 0
            })) : []
        };
       
        try {
            setIsLoading(false)
            if (initialData) {
                // Edit: Update MedicalCamp Data
                const response = await MedicalCampService.updateExistingCamp(payload)
                if (response.success) {
                    toast.success(response.message)
                    onSuccess()

                    // clearing Inputs
                    setInitialData(null)
                    // console.log("Success",response)
                }else {
                    toast.error(response.message || "Failed to Update Medical Camp.")
                }
            } else {
                const response = await MedicalCampService.addNewMedicalCamp(payload)
                if (response.success) {
                    toast.success(response.message)
                    onSuccess()

                     // clearing Inputs
                    setInitialData(null)
                } else {
                    toast.error(response.message || "Failed to Add Medical Camp.")
                    
                }
                // console.log(response)
            }
        } catch (error) {
            console.log(error);
            toast.error("Something went wrong. Please try again.");
        }finally{
            setIsLoading(true)
        }
    }
    // console.log("Submitting:", medicalCampDetails);
   
    // for Opening Doctors Dropdown
    const [isOpen, setIsOpen] = useState(false);

    const [showAllDoctors,setShowAllDoctors] = useState(false)

    const toggleDoctor = (doctorId: string) => {
        setMedicalCampDetails(prev => {
            const exists = prev.campDoctors.some(d => d.doctorId === doctorId);
            if (exists) {
                return {
                    ...prev,
                    campDoctors: prev.campDoctors.filter(d => d.doctorId !== doctorId)
                };
            }
            return {
                ...prev,
                campDoctors: [...prev.campDoctors, { doctorId, amount: 0 }]
            };
        });
    };
    const removeDoctor = (doctorId: string) => {
        setMedicalCampDetails(prev => ({
            ...prev,
            campDoctors: prev.campDoctors.filter((d) => d.doctorId !== doctorId)
        }))
    }

    return (
        <section className="absolute inset-0 z-50" style={{ height: "129vh" }}>
            <div
                className="absolute inset-0 bg-cover bg-center flex  justify-center px-2 pb-2"
                style={{
                    backgroundImage: `url(${transparentBg})`,
                    //   height: "inherit",
                }}
            >
                <div className="bg-white rounded-lg w-[750px] shadow-xl mt-5 py-8 px-10 h-fit">
                    {/* Modal Header */}
                    <div className="flex items-center justify-between border-b mb-7">
                        <h2 className="text-lg font-medium text-emerald-600">{initialData ? 'Update Medical Camp' : 'Create New Medical Camp'}</h2>
                        <button
                            onClick={onClose}
                            className="text-gray-400 hover:text-gray-500"
                        >
                            <X className="w-5 h-5" />
                        </button>
                    </div>
                    {/* Modal Header */}

                    <form className="w-full p-1" onSubmit={handleSubmit}>
                        {/* Camp Name */}
                        <div className="flex flex-col gap-7">
                            <div className="grid grid-cols-2 gap-4">
                                <div className="space-y-2">
                                    <label
                                        htmlFor="campName"
                                        className="block text-sm text-gray-600 font-medium"
                                    >
                                        Medcal Camp Name
                                    </label>
                                    <input
                                        id="campName"
                                        name="campName"
                                        type="text"
                                        value={medicalCampDetails.campName}
                                        onChange={(e) =>
                                            setMedicalCampDetails((prev) => ({
                                                ...prev,
                                                campName: e.target.value,
                                            }))
                                        }
                                        className="w-full px-3 py-2 border border-gray-300 outline-none rounded-lg focus:ring-1 focus:ring-emerald-500"
                                        placeholder="Enter Medical Camp Name"
                                    />
                                </div>
                                <div className="space-y-2">
                                    <label
                                        htmlFor="mobileNumber"
                                        className="block text-sm text-gray-600 font-medium"
                                    >
                                        Mobile Number
                                    </label>
                                    <input
                                        id="mobileNumber"
                                        name="mobileNumber"
                                        type="tel"
                                        value={medicalCampDetails.mobileNumber}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            if (/^\d{0,10}$/.test(value)) {
                                                setMedicalCampDetails((prev) => ({
                                                    ...prev,
                                                    mobileNumber: value,
                                                }));
                                            }
                                        }}
                                        className="w-full px-3 py-2 border border-gray-300 outline-none rounded-lg focus:ring-1 focus:ring-emerald-500"
                                        placeholder="Enter mobile number"
                                    />
                                </div>
                            </div>

                            {/* StartDate and EndDate */}
                            <div className="grid grid-cols-2 gap-4">
                                <div className="space-y-2">
                                    <label
                                        htmlFor="startDate"
                                        className="block text-sm text-gray-600 font-medium"
                                    >
                                        Start  Date
                                    </label>
                                    <input
                                        id="startDate"
                                        name="startDate"
                                        type="date"
                                        min={new Date().toISOString().split("T")[0]} // To prevent selection of past dates, the calendar will only show future dates starting from Today Date
                                        value={medicalCampDetails.campStartDate}
                                        onChange={(e) => {
                                            const value = e.target.value;

                                            setMedicalCampDetails((prev) => ({
                                                ...prev,
                                                campStartDate: value,
                                            }));

                                        }}
                                        className="w-full px-3 py-2 border border-gray-300 outline-none rounded-lg focus:ring-1 focus:ring-emerald-500"
                                        placeholder="Enter Start Date"
                                    />
                                </div>
                                <div className="space-y-2">
                                    <label
                                        htmlFor="endDate"
                                        className="block text-sm text-gray-600 font-medium"
                                    >
                                        End Date
                                    </label>
                                    <input
                                        id="endDate"
                                        name="endDate"
                                        type="date"
                                        min={medicalCampDetails.campStartDate } //To prevent selection of past dates, the calendar will only show future dates starting from the camp start date.
                                        value={medicalCampDetails.campEndDate}
                                        onChange={(e) => {
                                            const value = e.target.value;

                                            setMedicalCampDetails((prev) => ({
                                                ...prev,
                                                campEndDate: value,
                                            }));

                                        }}
                                        className="w-full px-3 py-2 border border-gray-300 outline-none rounded-lg focus:ring-1 focus:ring-emerald-500"
                                        placeholder="Enter End Date"
                                    />
                                </div>
                            </div>
                            {/* StartDate and EndDate */}

                            {/* Address,City,Pincode and State */}
                            <div className="space-y-2">
                                <label
                                    htmlFor="State"
                                    className="block text-sm text-gray-600 font-medium"
                                >
                                    Address
                                </label>
                                <div className="flex flex-col gap-5">
                                    <div className="grid grid-cols-3 gap-3">
                                        <div className="space-y-2">
                                            <input
                                                id="state"
                                                name="state"
                                                type="text"
                                                value={medicalCampDetails.state}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    if (/^[A-Za-z\s]*$/.test(value)) {
                                                        setMedicalCampDetails((prev) => ({
                                                            ...prev,
                                                            state: value
                                                        }));
                                                    }
                                                }}
                                                className="w-full px-3 py-2 border border-gray-300 outline-none rounded-lg focus:ring-1 focus:ring-emerald-500"
                                                placeholder="Enter state"
                                            />
                                        </div>
                                        <div className="space-y-2">
                                            <input
                                                id="city"
                                                name="city"
                                                type="text"
                                                value={medicalCampDetails.city}
                                                onChange={(e) => {
                                                    const value = e.target.value
                                                    if (/^[A-Za-z\s]*$/.test(value)) {
                                                        setMedicalCampDetails((prev) => ({
                                                            ...prev,
                                                            city: value
                                                        }))
                                                    }
                                                }}
                                                className="w-full px-3 py-2 border border-gray-300 outline-none rounded-lg focus:ring-1 focus:ring-emerald-500"
                                                placeholder="Enter city"
                                            />
                                        </div>
                                        <div className="space-y-2">
                                            <input
                                                type="text"
                                                value={medicalCampDetails.pincode}
                                                onChange={(e) => {
                                                    const value = e.target.value
                                                    if (value.length <= 6 && /^\d*$/.test(value)) {
                                                        setMedicalCampDetails((prev) => ({
                                                            ...prev,
                                                            pincode: value,
                                                        }))
                                                    }
                                                }}
                                                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-1 focus:ring-emerald-500"
                                                placeholder="Enter pincode"
                                            />
                                        </div>
                                    </div>

                                    {/* Address */}
                                    <div className="space-y-2">
                                        <textarea
                                            value={medicalCampDetails.campAddress}
                                            onChange={(e) =>
                                                setMedicalCampDetails((prev) => ({
                                                    ...prev,
                                                    campAddress: e.target.value,
                                                }))
                                            }
                                            className="resize-none w-full px-3 py-2 border border-gray-300 outline-none rounded-lg focus:ring-1 focus:ring-emerald-500"
                                            placeholder="Enter address"
                                        />
                                    </div>
                                    {/* Address */}
                                </div>
                            </div>
                            {/*Address, City,pincode and state */}

                            {/* Supervisor */}
                            <div className="space-y-2">
                                <span className="text-emerald-600 font-medium text-lg">Add New Supervisor</span>
                                <label
                                    htmlFor="name"
                                    className="block text-sm text-gray-600 font-medium"
                                >
                                    Supervisor Name
                                </label>
                                <input
                                    id="supervisorName"
                                    name="supervisorName"
                                    type="text"
                                    value={medicalCampDetails.campSupervisorName}
                                    onChange={(e) => {
                                        const value = e.target.value
                                        if (/^[A-Za-z\s]*$/.test(value)) {
                                            setMedicalCampDetails((prev) => ({
                                                ...prev,
                                                campSupervisorName: value,
                                            }))
                                        }
                                    }}
                                    className="w-full px-3 py-2 border border-gray-300 outline-none rounded-lg focus:ring-1 focus:ring-emerald-500"
                                    placeholder="Enter Supervisor Name"
                                />
                            </div>
                            {/* <div className="space-y-2">
                                <label className="block text-sm text-gray-600 font-medium">
                                    Supervisor
                                </label>
                                <select
                                    value={medicalCampDetails.campSupervisorId}
                                    onChange={(e) =>
                                        setMedicalCampDetails((prev) => ({
                                            ...prev,
                                            campSupervisorId: e.target.value,
                                        }))
                                    }
                                    className="w-full px-3 py-2 border border-gray-300 outline-none rounded-lg focus:ring-1 focus:ring-emerald-500"
                                >
                                    <option value="">Select Supervisor</option>
                                    {supervisiors.map((supervisor) => (
                                        <option key={supervisor.userId} value={supervisor.userId}>
                                            {supervisor.name}
                                        </option>
                                    ))}
                                </select>
                            </div> */}
                            {/* Supervisor */}

                            {/* Doctors */}
                            <div className="space-y-2">

                                <label className="block text-sm text-gray-600 font-medium">
                                    Doctors
                                </label>
                                {/* Dropdown Button */}
                                <div className="flex space-x-5">
                                    <button
                                        type="button"
                                        onClick={() => setIsOpen(!isOpen)}
                                        className="w-full flex items-center justify-between text-left px-4 py-2 border border-gray-300 rounded-lg focus:ring-1 focus:ring-emerald-500"
                                    >
                                        Select Doctors to Notify
                                        {!isOpen ? <ChevronDown className="w-5 h-5" /> : <ChevronUp className="w-5 h-5" />}
                                    </button>
                                    <button
                                        type="button"
                                        onClick={() => setIsOpen(!isOpen)}
                                        className="justify-self-end py-2 px-8 font-medium text-md rounded-lg flex items-center justify-center gap-2 border-[1.5px] border-[#199C4D] text-[#199C4D]">
                                        {isOpen ? 'Close' : 'Add'}
                                    </button>
                                </div>

                                {/* Dropdown Panel */}
                                {isOpen && (
                                    <div className="mt-2 w-full bg-white shadow-lg border rounded-lg z-10 overflow-y-auto max-h-48 hiddenScrollbar px-5">
                                        {doctors.map((doctor, index) => {
                                            const campDoctor = medicalCampDetails.campDoctors.find(d => d.doctorId === doctor.userId);
                                            return (

                                                <div
                                                    key={doctor.userId}
                                                    className="flex items-center justify-between p-3 border-b last:border-none"
                                                >
                                                    {/* Checkbox */}
                                                    <input
                                                        type="checkbox"
                                                        // checked={medicalCampDetails.campDoctors.some(d => d.doctorId === doctor.userId)}
                                                        checked={!!campDoctor}
                                                        onChange={() => toggleDoctor(doctor.userId)}
                                                        className="mr-3"
                                                    />

                                                    {/* Doctor details */}

                                                    <div className="flex-grow">
                                                        <div className="flex gap-2">
                                                            {doctor.profileImage && <img src={doctor.profileImage} alt='' className="rounded-full w-10 h-10" />}
                                                            <div>
                                                                <h4 className="text-gray-800 font-semibold">{doctor.name}</h4>
                                                                <p className="text-sm text-gray-500">
                                                                    {doctor.education} | {doctor.specialization} | {doctor.hospitalName}
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>


                                                    {/* Free label & Price */}
                                                    <div className="flex items-center gap-x-5">
                                                        <div className="flex gap-x-3">

                                                            <input
                                                                type="radio"
                                                                name={`amount-${doctor.userId}`}
                                                                id={`amount-free${doctor.userId}`}
                                                                checked={campDoctor?.amount === 0}
                                                                onChange={() => {
                                                                    setMedicalCampDetails(prev => ({
                                                                        ...prev,
                                                                        campDoctors: prev.campDoctors.map(d =>
                                                                            d.doctorId === doctor.userId ? { ...d, amount: 0 } : d
                                                                        )
                                                                    }));
                                                                }}
                                                            />
                                                            <span className="font-semibold text-lg">Free</span>
                                                        </div>
                                                        <div className="relative">
                                                            <span className="absolute inset-y-0 left-1 flex items-center text-gray-500 space-x-4 font-medium">₹</span>
                                                            <input type="number"
                                                                name={`amount-${doctor.userId}`}
                                                                id={`amount-paid${doctor.userId}`}
                                                                className="pl-5 px-2 py-1 border border-gray-300 outline-none rounded-lg focus:ring-1 focus:ring-emerald-500"
                                                                value={campDoctor?.amount !== 0 ? campDoctor?.amount || "" : ""}
                                                                onChange={(e) => {
                                                                    const amount = Number(e.target.value);
                                                                    setMedicalCampDetails(prev => ({
                                                                        ...prev,
                                                                        campDoctors: prev.campDoctors.map(d =>
                                                                            d.doctorId === doctor.userId ? { ...d, amount } : d
                                                                        )
                                                                    }));
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        })}
                                    </div>
                                )}
                            </div>
                            {/* Doctors */}

                            {/* Assigned Doctors */}
                            {/* Show scrollbar when the number of doctors exceeds 2 */}
                            {medicalCampDetails.campDoctors.length > 0 && <div className={`flex flex-row flex-wrap gap-x-5 gap-y-4  ${showAllDoctors ? 'overflow-y-auto max-h-48 hiddenScrollbar' : ''}`}>
                                {medicalCampDetails.campDoctors.slice(0, showAllDoctors ? medicalCampDetails.campDoctors.length : 2).map((CampDoctor) => {
                                    const doctorDetails = doctors.find(d => d.userId === CampDoctor.doctorId);
                                    return (
                                        <div key={CampDoctor.doctorId} className="border rounded-xl h-auto w-[300px]">
                                            <div className="bg-[#F2F9FF] flex gap-2 px-3 py-1">
                                                {doctorDetails?.profileImage && <img src={doctorDetails?.profileImage} alt="" className="rounded-full w-10 h-10" />}
                                                <div className="flex-grow min-h-[63px]">
                                                    <div className="flex justify-between">
                                                        <span className="text-[#33384B] text-lg font-bold">{doctorDetails?.name}</span>
                                                        <div className="cursor-pointer" onClick={() => {
                                                            removeDoctor(CampDoctor.doctorId)
                                                            // for disable ShowAllDoctors after removing two doctors
                                                            { medicalCampDetails.campDoctors.length < 4 && setShowAllDoctors(false) }
                                                        }}>
                                                            <Delete className="w-6 h-6 text-[#EF4444]" />
                                                        </div>
                                                    </div>
                                                    <p className="text-[#7A7F86] text-sm">{doctorDetails?.education}. {doctorDetails?.specialization} | {doctorDetails?.hospitalName}</p>
                                                </div>
                                            </div>
                                            <div className="pt-5 pl-5">
                                                <span>
                                                    Consultation Fee: <span className="text-[#00B743] text-sm">{CampDoctor.amount === 0 ? 'Free' : `₹ ${CampDoctor.amount}`}</span>
                                                </span>
                                            </div>
                                        </div>


                                    );
                                })}
                            </div>}
                            {/* Show this tag when the number of doctors exceeds 2 */}
                            {medicalCampDetails.campDoctors.length > 2 && !showAllDoctors && (
                                <>
                                    <span className='text-[#0997FF] text-base font-bold cursor-pointer underline' onClick={() => setShowAllDoctors(true)}>
                                        +{medicalCampDetails.campDoctors.length - 2} More
                                    </span>
                                </>

                            )}
                            {/* Assigned Doctors */}
                            
                            {/* Username & Password */}
                            <div className="grid grid-cols-2 gap-4  border-b-1 border-gray-400 bg-gray-200/40 p-2">
                                <div className="space-y-2">
                                    <label
                                        htmlFor="username"
                                        className="block text-sm text-gray-600 font-medium"
                                    >
                                        User Name
                                    </label>
                                    <input
                                        id="username"
                                        name="username"
                                        type="text"
                                        value={medicalCampDetails.username}
                                        onChange={(e) =>
                                            setMedicalCampDetails((prev) => ({
                                                ...prev,
                                                username: e.target.value,
                                            }))
                                        }
                                        className="w-full px-3 py-2 border border-gray-300 outline-none rounded-lg focus:ring-1 focus:ring-emerald-500"
                                        placeholder="Enter username"
                                    />
                                </div>
                                <div className="space-y-2 relative">
                                    <label
                                        htmlFor="password"
                                        className="block text-sm text-gray-600 font-medium"
                                    >
                                        Password
                                    </label>
                                    <div className="relative">
                                        <input
                                            id="password"
                                            name="password"
                                            type={showPassword ? "text" : "password"}
                                            value={medicalCampDetails.password}
                                            onChange={(e) =>
                                                setMedicalCampDetails((prev) => ({
                                                    ...prev,
                                                    password: e.target.value,
                                                }))
                                            }
                                            className="w-full px-3 py-2 border border-gray-300 outline-none rounded-lg focus:ring-1 focus:ring-emerald-500 pr-10"
                                            placeholder="Enter password"
                                        />
                                        <button
                                            type="button"
                                            onClick={() => setShowPassword((prev) => !prev)}
                                            className="absolute inset-y-0 right-3 flex items-center text-gray-500"
                                        >
                                            {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                                        </button>
                                    </div>
                                    <span className="text-xs text-gray-500 ">Password must be contain at least one uppercase letter<br></br>(A-Z), one number (0-9), and one special character<br></br>(e.g., @, #, $, %).</span>
                                </div>
                            </div>
                            {/* Username & Password */}

                            {/* Buttons Box */}
                            <div className="flex items-center flex-row-reverse justify-start gap-5">
                                <button
                                    type="submit"
                                    onClick={handleSubmit}
                                    className="w-[120px]  px-4 py-2 text-sm font-medium text-white bg-emerald-600 rounded-lg hover:bg-emerald-700 disabled:bg-gray-200 disabled:cursor-not-allowed"
                                >
                                    {isLoading ? (initialData ? 'Update' : 'Create Camp') : !initialData ? 'Creating...' : 'Updating...'} 
                                </button>

                                <button
                                    type="button"
                                    onClick={onClose}
                                    className="w-[120px] px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200"
                                >
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </section>

    )
}